import { call, put, select } from "redux-saga/effects";
import { normalize, schema } from "normalizr";

import { showError } from "../../utils/sagasErrorHandler";

import { isLoadingTenantsAction, storeTenantsAction } from "./actions";
import { getTenantsRequest } from "./api";
import { tenantsSelector } from "./selectors";

const tenantsSchema = new schema.Entity("tenants", undefined , { idAttribute: "code" });
const tenantsListSchema = new schema.Array(tenantsSchema);

function* getTenantsWorker() {
    try {
        const { ids } = yield select(tenantsSelector);
        if(!ids.length){
            yield put(isLoadingTenantsAction(true));
            const { tenants } = yield call(getTenantsRequest);
            const { result, entities } = normalize(tenants, tenantsListSchema);
            yield put(storeTenantsAction({
                isLoadingTenantsAction: false,
                tenants: entities.tenants,
                ids: result
            }));
        }
    } catch (error) {
        yield put(isLoadingTenantsAction(false));
        showError(error);
    }
}

export function* getTenants() {
    yield call(getTenantsWorker);
}
